// Constants for the UPB Beta copilot (Marco). Mirrors the sibling component constants modules:
// endpoint path literals and small enums live here instead of inline in the components.

// Marco backend endpoint paths (relative to SERVER from lib/networking/endpoints).
export const MARCO_CHAT_PATH = '/api/v1/marco/chat';
export const MARCO_REPORTS_PATH = '/api/v1/marco/reports';
export const MARCO_KNOWLEDGE_PATH = '/api/v1/marco/knowledge';

// A2uiSurface ChartCard "view" toggle states.
export const A2UI_VIEW_TYPES = {
  CHART: 'chart',
  LIST: 'list',
};

// FsaCopilot answer-detail persona toggle.
export const PERSONAS = {
  BUSINESS: 'business',
  TECHNICAL: 'technical',
};

// FsaCopilot ReportControl lifecycle states.
export const REPORT_STATES = {
  IDLE: 'idle',
  BUSY: 'busy',
  DONE: 'done',
  ERROR: 'error',
};

// ReportControl background-generation polling: reports are authored off-request (the HTML can take
// 30-90s), so after create returns a pending id the UI polls status every 2.5s, up to ~2.5 min.
export const REPORT_POLL_INTERVAL_MS = 2500;
export const REPORT_POLL_MAX = 60;

// Backend report-generation status (from create + the status poll), distinct from the UI
// REPORT_STATES lifecycle above.
export const REPORT_GEN_STATUS = {
  PENDING: 'pending',
  READY: 'ready',
};
